import { SIGNUP_STEPS } from '../../../types/enum';
import { isString } from '../../../lib/validation';
import TextInput from '../../../components/textInput';

const FullName = ({
  firstname,
  setFirstname,
  lastname,
  setLastname,
  setCurrentStep,
}) => {
  const handleInput = (key) => (e) => {
    const value = String(e.target.value);
    if (key === 'firstname') {
      setFirstname(value);
    }
    if (key === 'lastname') {
      setLastname(value);
    }
  };

  const handleNext = () => {
    try {
      isString(firstname);
      setFirstname(firstname.trim());
      isString(lastname);
      setLastname(lastname.trim());
      setCurrentStep(SIGNUP_STEPS.NICKNAME);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-4xl'>What's your name?</h1>
      <div className='mb-5 space-y-2'>
        <input
          type='text'
          placeholder='First name'
          className='w-full bg-white rounded-full py-2 px-4 '
          onChange={handleInput('firstname')}
          value={firstname}
          maxLength={32}
        />
        <input
          type='text'
          placeholder='Last name'
          className='w-full bg-white rounded-full py-2 px-4 '
          onChange={handleInput('lastname')}
          value={lastname}
          maxLength={32}
        />
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !firstname || !lastname
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!firstname || !lastname}
      >
        Next
      </button>
    </div>
  );
};

export default FullName;
